import React from "react";
import { inputCls, labelCls } from "./shared";
import { getVideoCategories, VIDEO_CATEGORIES } from "../../lib/videoTags";

export default function DescriptionTab({ record, setField }) {
  const selectedCategories = getVideoCategories(record.tags);

  return (
    <div className="space-y-6">
      <fieldset>
        <legend className={labelCls}>Categories</legend>
        <div className="flex flex-wrap gap-2" data-testid="video-category-picker">
          {VIDEO_CATEGORIES.map((category) => {
            const selected = selectedCategories.includes(category);
            return (
              <button type="button" key={category} aria-pressed={selected}
                onClick={() => setField("tags", selected
                  ? selectedCategories.filter((item) => item !== category)
                  : getVideoCategories([...selectedCategories, category]))}
                className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition ${selected
                  ? "border-cyan-400 bg-cyan-900/30 text-cyan-200"
                  : "border-zinc-700 text-zinc-400 hover:border-zinc-500 hover:text-white"}`}>
                {category}
              </button>
            );
          })}
        </div>
      </fieldset>
      <fieldset className="space-y-2">
        <legend className={labelCls}>Publish visibility</legend>
        <div className="flex flex-wrap gap-4">
          {[["free", "Free"], ["members", "Basic Members"], ["vip", "VIP"], ["bts", "Behind the Scenes"]].map(([value, label]) => (
            <label key={value} className="flex items-center gap-2 text-sm text-zinc-300">
              <input type="checkbox" className="accent-cyan-500" checked={(record.visibility || []).includes(value)}
                onChange={(e) => {
                  const current = record.visibility || [];
                  setField("visibility", e.target.checked ? [...current, value] : current.filter((item) => item !== value));
                }} />
              {label}
            </label>
          ))}
        </div>
      </fieldset>
      <div>
        <label htmlFor="mv-public-desc" className={labelCls}>Public / Store Description</label>
        <textarea id="mv-public-desc" rows={4} className={`${inputCls} resize-y`} value={record.description || ""}
          onChange={(e) => setField("description", e.target.value)}
          placeholder="Public store and video detail description" />
      </div>
      <div>
        <label htmlFor="mv-free-desc" className={labelCls}>🆓 Free Members Description (Free Tier)</label>
        <textarea id="mv-free-desc" rows={4} className={`${inputCls} resize-y`} value={record.free_description || ""}
          onChange={(e) => setField("free_description", e.target.value)}
          placeholder="Free members cannot watch the full video." />
        <p className="text-xs text-zinc-500 mt-1.5">Visible to free members on the video page.</p>
      </div>
      <p className="text-xs text-zinc-500">Basic and VIP members use the shared description above.</p>
      <div>
        <label htmlFor="mv-promo-note" className={labelCls}>⚡ Promo Note (Mood/vibe for AI caption generator)</label>
        <textarea id="mv-promo-note" rows={3} className={`${inputCls} resize-y`} value={record.promo_note || ""}
          onChange={(e) => setField("promo_note", e.target.value)}
          placeholder="e.g. intense power dynamic, raw muscle action" />
        <p className="text-xs text-zinc-500 mt-1.5">AI combines this with cast, tags, and runtime to generate promo captions. Internal only; never displayed publicly.</p>
      </div>
    </div>
  );
}
